import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { SupportGuidelineQuery, SupportGuidelineQueryVariables } from '@/shared/api';
import SUPPORT_GUIDELINE from '../queries/supportGuideline';

/**
 * Loads the support guideline content shown on the support page. Runs the SUPPORT_GUIDELINE query and throws the first GraphQL error message when supportGuideline is nil.
 *
 * @returns The support guideline content.
 */
const fetchSupportGuideline = async () => {
  const client = createClient();
  const userResult = await client.query<SupportGuidelineQuery, SupportGuidelineQueryVariables>({
    query: SUPPORT_GUIDELINE,
  });
  const { data, errors } = userResult;
  const { supportGuideline } = data;
  if (_.isNil(supportGuideline) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return supportGuideline;
};

export default fetchSupportGuideline;
